import { formatters } from '@utils/formattersV2';
import { SummaryCard } from '../SummaryCard';
import { SummaryTabView } from '../SummaryTabView';
import {
  Lci3Report,
  Lci3SalesMetrics,
} from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { SalesMetrics } from './SalesMetrics';
import { ContributionMetrics } from './ContributionMetrics';
import { SalesHighlights } from '../../../Highlights';
import { Campaign } from '@features/campaigns/subdomains/visitation/api';
import { RoasHeroMetric } from './RoasHeroMetric';

type SalesSummaryProps = {
  campaign: Pick<Campaign, 'adSpend' | 'id' | 'name' | 'startDate' | 'endDate'>;
  selectedReport: Lci3Report;
  allReports: Lci3Report[];
  reportDate: string;
  salesMetrics: Lci3SalesMetrics;
};

export const SalesSummary = (props: SalesSummaryProps) => {
  return (
    <SummaryCard
      label="Sales Summary"
      color="sales"
      metrics={[
        {
          key: 'iroas',
          render: () => (
            <RoasHeroMetric
              campaign={props.campaign}
              reportDate={props.reportDate}
              sales={props.salesMetrics.incrementalSales.total}
              metricProps={{
                colorScheme: 'sales',
                label: 'IROAS (Incremental Return on Ad Spend)',
                valueFormatter: formatters.currency,
              }}
            />
          ),
        },
        {
          key: 'roas',
          render: () => (
            <RoasHeroMetric
              campaign={props.campaign}
              reportDate={props.reportDate}
              sales={props.salesMetrics.totalProjectedSales.total}
              metricProps={{
                colorScheme: 'sales',
                label: 'ROAS (Return on Ad Spend)',
                valueFormatter: formatters.currency,
              }}
            />
          ),
        },
      ]}
      campaignId={props.campaign.id}
      allReports={props.allReports}
    >
      <SummaryTabView
        tabs={[
          {
            label: 'Sales Metrics',
            content: (
              <SalesMetrics
                reports={props.allReports}
                highlightsComponent={
                  <SalesHighlights
                    campaignName={props.campaign.name}
                    salesMetrics={props.salesMetrics}
                    uniqueUsers={props.selectedReport.visitMetrics.uniqueUsers}
                  />
                }
              />
            ),
          },
          {
            label: 'Contribution Metrics',
            content: (
              <ContributionMetrics
                reports={props.allReports}
                salesMetrics={props.salesMetrics}
                highlightsComponent={
                  <SalesHighlights
                    campaignName={props.campaign.name}
                    salesMetrics={props.salesMetrics}
                    uniqueUsers={props.selectedReport.visitMetrics.uniqueUsers}
                  />
                }
              />
            ),
          },
        ]}
      />
    </SummaryCard>
  );
};
